export const cleanFilename = (filename: string): string => {
    const apiUrl = `${import.meta.env.VITE_API_DOMAIN}:${import.meta.env.VITE_API_PORT}`;
    if (filename.startsWith(`${apiUrl}/data/data`)) {
      return filename.replace(`${apiUrl}/data/data`, `${apiUrl}/data`);
    }
    return filename;
  };
  
  export const getFileType = (mimeType: string, filename: string): string => {
    const extension = filename.split('.').pop()?.toLowerCase();
    
    if (mimeType.includes('image/')) return 'image';
    if (mimeType.includes('pdf')) return 'pdf';
    if (mimeType.includes('msword') || mimeType.includes('wordprocessingml') || 
        mimeType.includes('opendocument.text') || ['doc', 'docx', 'odt'].includes(extension || '')) {
      return 'word';
    }
    if (mimeType.includes('excel') || mimeType.includes('spreadsheetml') || 
        mimeType.includes('opendocument.spreadsheet') || ['xls', 'xlsx', 'ods'].includes(extension || '')) {
      return 'excel';
    }
    if (mimeType.includes('powerpoint') || mimeType.includes('presentationml') || 
        mimeType.includes('opendocument.presentation') || ['ppt', 'pptx', 'odp'].includes(extension || '')) {
      return 'powerpoint';
    }
    if (mimeType.includes('opendocument.graphics') || extension === 'odg') return 'graphics';
    
    return 'other';
  };
  
  export const downloadFile = (filename: string): void => {
    const link = document.createElement('a');
    link.href = cleanFilename(filename);
    link.download = filename.split('/').pop() || 'document';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  export const getFileTypeLabel = (fileType: string): string => {
    const labels: Record<string, string> = {
      word: 'Word Document',
      excel: 'Excel Spreadsheet',
      powerpoint: 'PowerPoint Presentation',
      graphics: 'Graphics Document',
      pdf: 'PDF Document',
      image: 'Image',
    };
    return labels[fileType] || 'Document';
  };